function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 17,
  r: 6,
  stroke: "#FFC700",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25 4H27V8H25V4Z",
  fill: "#FFC700"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25 26H27V30H25V26Z",
  fill: "#FFC700"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M39 16H35V18H39V16Z",
  fill: "#FFC700"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13 16H17V18H13V16Z",
  fill: "#FFC700"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M34.4853 7.10052L35.8995 8.51473L33.0711 11.3432L31.6569 9.92894L34.4853 7.10052Z",
  fill: "#FFC700"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9289 22.6569L20.3431 24.0711L17.5147 26.8995L16.1005 25.4853L18.9289 22.6569Z",
  fill: "#FFC700"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M35.8995 25.4853L33.0711 22.6569L31.6569 24.0711L34.4853 26.8995L35.8995 25.4853Z",
  fill: "#FFC700"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5147 7.10052L20.3431 9.92894L18.9289 11.3432L16.1005 8.51473L17.5147 7.10052Z",
  fill: "#FFC700"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M2 23C2 29.6274 7.37258 35 14 35H27C31.9706 35 36 30.9706 36 26C36 21.0294 31.9706 17 27 17C26.161 17 25.3489 17.1148 24.5784 17.3295C22.5545 13.5618 18.5764 11 14 11C7.37258 11 2 16.3726 2 23Z",
  fill: "#DDDDDD",
  fillOpacity: 0.94
});

var SvgMixed = function SvgMixed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMixed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mixed.9e2d6520.svg";
export { ForwardRef as ReactComponent };